import React from 'react';
import { Form, Input,message, Button,Select,Switch,Table,Spin,Collapse,Popconfirm,Popover } from 'antd';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import * as reactstrp from 'reactstrap';

import { 
  DeleteOutlined,
  FundViewOutlined,
  LoadingOutlined
  
} from '@ant-design/icons';
import uuid from 'react-uuid'
import moment from 'moment';
import {
  Col,
  Row,
} from 'reactstrap';


const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { Panel } = Collapse;
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

class RegionForm extends React.Component {

  state = {
    name:''  
    }

  componentDidMount(){
    this.setState({requestsent:false})
  }

 
//handle data submission
handleDatasubmission=()=>{

  if (this.state.name===""){
    message.info("Please enter name")

  }else{

    this.setState({requestsent:true})

    let form_data = new FormData();
    form_data.append('name',this.state.name);

    axios.post(serverconfig.backendserverurl+'/api/regions/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
    .then(res =>{
      this.setState({requestsent:false})
      window.location.reload(false)
      message.info("Successfully created region")
    })
  .catch(error => console.log(error))

  }


}


  render(){

    if(this.state.requestsent===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} size={200} />
        </div>
      );

    }else{

      return (
        <div>
         
           <Form
            onFinish={(event) => this.handleDatasubmission(event)}
            >
            <FormItem label="Region Name" >
              <Input 
              name="name" 
              placeholder="Put a name here." 
              value={this.state.name} 
              onChange={(e) => this.setState({ name: e.target.value})} 
              />
             </FormItem>
      
            <FormItem >
              <Button  type="primary" htmlType="submit">Submit</Button>
            </FormItem>
            </Form>

        </div>
      );

    }

  }

}

export default RegionForm;
